import orders from './modules/orders'
import order from './modules/order'

export default {
  modules: {
    orders,
    order
  },
  state: {
    count: 0
  },
  mutations: {
    increment (state) {
      state.count++
    }
  }
}
